
import Vue from 'vue';
import Notification24 from '@carbon/icons-vue/es/notification/24';
import ChevronDown24 from '@carbon/icons-vue/es/chevron--down/24';
import ChevronUp24 from '@carbon/icons-vue/es/chevron--up/24';

export default Vue.extend({
  name: 'NotificationsHeader',

  components: {
    Notification24,
    ChevronDown24,
    ChevronUp24,
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
    notificationsNum: {
      type: Number,
      required: true,
      default: 0,
    },
    hasRedNotifications: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
